var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('div',[_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.simposiums,"item-key":"name"},on:{"click:row":_vm.openSimposium}})],1)])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }